import { type CustomWorklist } from '@/Models/GenericWorklist/CustomWorklist';
import { t } from 'i18next';
import { DobSelect } from '@dedalusdiit/dob-components';
import { ReactElement } from 'react';

interface WorklistOption {
    value: number | '';
    label: string;
}

const SavedFilterSelect = (
    props: Readonly<{
        savedCustomWorklists: CustomWorklist[];
        currentCustomWorklist: CustomWorklist | null;
        selectSavedFilter: (id: number | null) => void;
        isDisabled: boolean;
    }>,
): ReactElement => {
    const { savedCustomWorklists, selectSavedFilter, isDisabled, currentCustomWorklist } = props;

    const emptyOption = { value: '', label: t('Empty') } as const;
    const savedCustomOptions = savedCustomWorklists.map((worklist) => ({ value: worklist.ID, label: worklist.Name }));
    const allOptions: WorklistOption[] = [emptyOption, ...savedCustomOptions];

    let selectedOption: WorklistOption = emptyOption;
    if (currentCustomWorklist !== null) {
        const currentWorklist = allOptions.find((option) => option.value === currentCustomWorklist?.ID);
        if (currentWorklist) {
            selectedOption = currentWorklist;
        }
    }

    const onChangeHandler = (selectedOption: WorklistOption | null): void => {
        if (!selectedOption || selectedOption.value === '') {
            return selectSavedFilter(null);
        }
        selectSavedFilter(selectedOption.value);
    };

    return <DobSelect onChange={onChangeHandler} disabled={isDisabled} optionSelected={selectedOption} options={allOptions} />;
};

export default SavedFilterSelect;
